export default __webpack_public_path__ + "static/media/female@2x.f9b38dbb.png";